export const titleTypes = {
  PAGE: 'page',
  SECTION: 'section',
}

export const tagTypes = {
  CARD: 'card',
  STEP: 'step',
}
